import { firebase } from "./app";
import "firebase/storage";

export const storage = firebase.storage();
